import React, { useEffect, useState } from "react";
import { Navigate, Route, Routes, useParams } from "react-router-dom";
import Cookies from "js-cookie";
import LoginPage from "../../pages/LoginPage";
import Dashboard from "../../pages/Dashboard";
import Loader from "../common/Loader";
import { useAuth } from "../../context/AuthContext";
import { Roles } from "../common/roles";
//import AdminRoute from "../../layouts/AdminRoute";
import AdminDashboard from "../admin/AdminDashboard";
import AuthLayout from "../../layouts/AuthLayout";
import AdminDashboardBookings from "../admin/AdminDashboardBookings";
import AdminDashboardGuides from "../admin/AdminDashboardGuides";
import AdminDashboardCoordinators from "../admin/AdminDashboardCoordinators";
import AdminDashboardTours from "../admin/AdminDashboardTours";
import AdminDashboardReviews from "../admin/AdminDashboardReviews";
import AdminDashboardInvoices from "../admin/AdminDashboardInvoices";
import GuideDashboard from "../guides/GuideDashboard";
import GuideAvailability from "../guides/GuideAvailability";
import GuideFinance from "../guides/GuideFinance";
import GuideReviews from "../guides/GuideReviews";
import Header from "../common/Header";
import GuideProfile from "../guides/GuideProfile";
import CoordinatorDashboard from "../coordinators/CoordinatorDashboard";
import ResetPassword from "../auth/ResetPassword";
//import {Roles} from "../common/roles";

const UUID_PATTERN = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

const isGuideReviewId = (value?: string): value is string =>
    Boolean(value && UUID_PATTERN.test(value));

const ReviewIdRedirect = () => {
    const { reviewId } = useParams<{ reviewId: string }>();
    const { user, isAuthenticated, login } = useAuth();
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        const token = Cookies.get("accessToken");
        if (token && !isAuthenticated) {
            login(token);
        }
        setIsLoading(false);
    }, [isAuthenticated, login]);

    if (!isGuideReviewId(reviewId)) {
        return <Navigate to="/" replace />;
    }

    if (isLoading) {
        return <Loader />;
    }

    if (!isAuthenticated || !user) {
        return <Navigate to="/" replace />;
    }

    if (user.role[0] === Roles.ADMIN) {
        return <Navigate to="/admin/reviews" replace />;
    }

    if (user.role[0] === Roles.GUIDE) {
        return <Navigate to="/guide/reviews" replace />;
    }

    return <Navigate to="/" replace />;
};

const AppRouter = () => {
    return (
        <>
            <Header />
            <Routes>
                <Route path="/" element={<LoginPage />} />
                <Route path="/login" element={<LoginPage />} />
                <Route path="/reset-password" element={<ResetPassword />} />
                {/*<Route path="/admin" element={<AdminDashboard />} />*/}
                <Route
                    path="/admin"
                    element={
                        <AuthLayout>
                            <AdminDashboard />
                        </AuthLayout>
                    }
                />
                <Route
                    path="/admin/guides"
                    element={
                        <AuthLayout>
                            <AdminDashboardGuides />
                        </AuthLayout>
                    }
                />
                <Route
                    path="/admin/coordinators"
                    element={
                        <AuthLayout>
                            <AdminDashboardCoordinators />
                        </AuthLayout>
                    }
                />
                <Route
                    path="/admin/tours"
                    element={
                        <AuthLayout>
                            <AdminDashboardTours />
                        </AuthLayout>
                    }
                />
                <Route
                    path="/admin/bookings"
                    element={
                        <AuthLayout>
                            <AdminDashboardBookings />
                        </AuthLayout>
                    }
                />
                <Route
                    path="/admin/reviews"
                    element={
                        <AuthLayout>
                            <AdminDashboardReviews />
                        </AuthLayout>
                    }
                />
                <Route
                    path="/admin/invoices"
                    element={
                        <AuthLayout>
                            <AdminDashboardInvoices />
                        </AuthLayout>
                    }
                />
                <Route path="/dashboard" element={<Dashboard />} />
                <Route
                    path="/guide"
                    element={
                        <AuthLayout>
                            <GuideDashboard />
                        </AuthLayout>
                    }
                />
                <Route
                    path="/guide/availability"
                    element={
                        <AuthLayout>
                            <GuideAvailability />
                        </AuthLayout>
                    }
                />
                <Route
                    path="/guide/finance"
                    element={
                        <AuthLayout>
                            <GuideFinance />
                        </AuthLayout>
                    }
                />
                <Route
                    path="/guide/reviews"
                    element={
                        <AuthLayout>
                            <GuideReviews />
                        </AuthLayout>
                    }
                />
                <Route
                    path="/guide/profile"
                    element={
                        <AuthLayout>
                            <GuideProfile />
                        </AuthLayout>
                    }
                />
                <Route
                    path="/coordinator"
                    element={
                        <AuthLayout>
                            <CoordinatorDashboard />
                        </AuthLayout>
                    }
                />
                <Route path="/:reviewId" element={<ReviewIdRedirect />} />

                {/* Admin Route Wrapper */}
                {/*<Route element={<AdminRoute allowedRoles={[Roles.ADMIN]} />}>*/}
                {/*</Route>*/}
            </Routes>
        </>
    );
};

export default AppRouter;
